import { createSelector } from 'reselect'
import { featureStateSelector } from './featureStateSelector'

export const isLoadingListOverviewReportSelector = createSelector(
  featureStateSelector,
  state => state.UIState.list.isLoading
)

export default isLoadingListOverviewReportSelector
